/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams, useLocation } from 'react-router-dom';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
import ProjectForm from '../../components/ProjectForm/ProjectForm';
import './cell-details.scss';
import Tasks from '../../components/Tasks/Tasks';
import { SpinnerSmall } from '@eyesee/eyesee-hub-npm-ui';
import { useHistory } from 'react-router';

const CellDetails = observer(() => {
    const { cell_id, project_id }: { cell_id: string; project_id: string } = useParams();
    let location = useLocation();
    let history = useHistory();

    useEffect(() => {
        projectDetailsData.cellId = cell_id;

        // FIX ME
        if (!projectDetailsData.project && !location.pathname.includes('new-project')) {
            projectDetailsStore.getProject(project_id);
        }
    }, [cell_id]);

    const goToCell = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, str: 'prev' | 'next') => {
      e.preventDefault()
      const indexOfCurrentCell = projectDetailsData?.project?.cells?.findIndex(cell => cell.id ===cell_id)
      const cellIndex = str === 'prev' ? projectDetailsData.project?.cells[Number(indexOfCurrentCell) - 1].id : 
        projectDetailsData.project?.cells[Number(indexOfCurrentCell) + 1].id;
      //* Leave this comment, maybe Data change their minds over this.
      // if(!projectDetailsData.isDataSaved) {
      //   if(!window.confirm("Are you sure you want to leave without saving your work?")) {
      //     return;
      //   } 
      //   else {
      //     projectDetailsData.isDataSaved = true;
      //     history.push(`/projects/${project_id}/cell${cellIndex}`);
      //   }
      // } else {
      //   projectDetailsData.isDataSaved = true;
      //   history.push(`/projects/${project_id}/cell${cellIndex}`);
      // }
      history.push(`/projects/${project_id}/cell${cellIndex}`);
    };

    const isCellLinkDisabled = (str: 'prev' | 'next') => {
      if (!projectDetailsData.project) return;
      let currentIndex = projectDetailsData.project.cells.findIndex(cell => cell.id ===cell_id)
      // alert(currentIndex)
      if (str === 'prev') {
          return !! (currentIndex > 0);
      }
      if (str === 'next') {
          return !!(currentIndex < projectDetailsData.project.cells.length - 1);
      }
    }

    let cell = projectDetailsData.project?.cells.find((cell) => cell.id === cell_id);
    if (!cell) return null;
    if(!projectDetailsData.project) return null;

    return (
        <div className="cell-wrapper">
          <div className="cell-wrapper-header">
            <div className="cell-wrapper-header__heading">
                <h4>Project - {projectDetailsData.project.name}</h4>
            </div>

              <div className="cell-wrapper-header__heading">
                <h5>Cell - {cell.name}</h5>
              </div>

              <div className="cell-wrapper-header__heading__last">
                <a href="#"
                  className={`${isCellLinkDisabled('prev') ? '' : 'disabled'}`}
                  onClick={e => goToCell(e, 'prev')}
                >
                  <i title="previous" className={`material-icons ${isCellLinkDisabled('prev') ? '' : 'disabled'}`}>
                      keyboard_arrow_left
                  </i>
                  Previous
                </a>
                <span className="cell-wrapper__header__separator">|</span>
                <a href="#"
                  className={`${isCellLinkDisabled('next') ? '' : 'disabled'}`}
                  onClick={e => goToCell(e, 'next')}
                >
                  Next{' '}
                  <i title="next" className={`material-icons ${isCellLinkDisabled('next') ? '' : 'disabled'}`}>
                      keyboard_arrow_right
                  </i>
                </a>
              </div>
          </div>
            


            {projectDetailsData.state === 'loading' ? (
                <div className="project-spinner">
                    <SpinnerSmall />
                </div>
            ) : (
                <>
                    {' '}
                    <ProjectForm
                        linkPath={{ name: `/projects/${project_id}`, title: 'project' }}
                        data={cell}
                    />
                    <div className="cell-wrapper__tasks">
                        <Tasks tasks={cell.tasks} />
                    </div>
                </>
            )}
        </div>
    );
});
export default CellDetails;
